import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import FourOpinionsEmbed from '../components/Exercise/FourOpinionsEmbed';

const FourOpinionsNode = Node.create({
  name: 'fourOpinionsExercise',

  group: 'block',

  atom: true,

  draggable: true,

  addAttributes() {
    return {
      title: {
        default: 'Four Opinions',
        parseHTML: element => element.getAttribute('title') || 'Four Opinions',
        renderHTML: attributes => {
          if (attributes.title) {
            return {
              title: attributes.title
            };
          }
          return {};
        }
      },
      level: {
        default: 'B1',
        parseHTML: element => element.getAttribute('level') || 'B1',
        renderHTML: attributes => {
          if (attributes.level) {
            return {
              level: attributes.level
            };
          }
          return {};
        }
      },
      topic: {
        default: '',
        parseHTML: element => element.getAttribute('topic') || '',
        renderHTML: attributes => {
          if (attributes.topic) {
            return {
              topic: attributes.topic
            };
          }
          return {};
        }
      },
      opinions: {
        default: [],
        parseHTML: element => {
          const data = element.getAttribute('opinions');
          if (data) {
            try { return JSON.parse(data); } catch { return []; }
          }
          return [];
        },
        renderHTML: attributes => {
          if (attributes.opinions) {
            return { opinions: JSON.stringify(attributes.opinions) };
          }
          return {};
        }
      },
      exerciseId: {
        default: null,
        parseHTML: element => element.getAttribute('data-exercise-id') || null,
        renderHTML: attributes => attributes.exerciseId ? { 'data-exercise-id': attributes.exerciseId } : {}
      }
    };
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-type="four-opinions-exercise"]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-type': 'four-opinions-exercise' })];
  },

  addCommands() {
    return {
      insertFourOpinionsExercise:
        (attributes = {}) =>
        ({ commands }) => {
          return commands.insertContent({ type: this.name, attrs: attributes });
        },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(FourOpinionsEmbed);
  },
});

export default FourOpinionsNode; 